/* eslint-disable import/no-duplicates */
/* eslint-disable no-unused-vars */
import React from "react"

// Dashboard
import EventManagement from "../dashboard/EventManagement"
import SalesMonitoring from "../dashboard/SalesMonitoring"
import WebsiteAnalytics from "../dashboard/WebsiteAnalytics"
import FinanceMonitoring from "../dashboard/FinanceMonitoring"
import Cryptocurrency from "../dashboard/Cryptocurrency"
import HelpdeskService from "../dashboard/HelpdeskService"
import StorageManagement from "../dashboard/StorageManagement"
import ProductManagement from "../dashboard/ProductManagement"

// Apps
import GalleryMusic from "../apps/GalleryMusic"
import GalleryVideo from "../apps/GalleryVideo"
import Tasks from "../apps/Tasks"
import Contacts from "../apps/Contacts"
import Chat from "../apps/Chat"
import AppCalendar from "../apps/AppCalendar"
import Email from "../apps/Email"
import FileManager from "../apps/FileManager"

// Pages
import Pricing from "../pages/Pricing"
import Faq from "../pages/Faq"
import Profile from "../pages/Profile"
import People from "../pages/People"
import Activity from "../pages/Activity"
import Events from "../pages/Events"
import Settings from "../pages/Settings"

// UI Elements
import LayoutColumns from "../docs/LayoutColumns"
import LayoutGrid from "../docs/LayoutGrid"
import LayoutGutters from "../docs/LayoutGutters"
import Accordions from "../docs/Accordions"
import Alerts from "../docs/Alerts"
import Avatars from "../docs/Avatars"
import Badges from "../docs/Badges"
import Breadcrumbs from "../docs/Breadcrumbs"
import Buttons from "../docs/Buttons"
import Cards from "../docs/Cards"
import Carousels from "../docs/Carousels"
import Dropdowns from "../docs/Dropdowns"
import Images from "../docs/Images"
import Listgroup from "../docs/Listgroup"
import Markers from "../docs/Markers"
import Modals from "../docs/Modals"
import NavTabs from "../docs/NavTabs"
import OffCanvas from "../docs/OffCanvas"
import Paginations from "../docs/Paginations"
import Placeholders from "../docs/Placeholders"
import Popovers from "../docs/Popovers"
import Progress from "../docs/Progress"
import Spinners from "../docs/Spinners"
import Toasts from "../docs/Toasts"
import Tooltips from "../docs/Tooltips"
import Tables from "../docs/Tables"
import FormElements from "../docs/FormElements"
import FormSelects from "../docs/FormSelects"
import FormChecksRadios from "../docs/FormChecksRadios"
import FormRange from "../docs/FormRange"
import FormPickers from "../docs/FormPickers"
import FormLayouts from "../docs/FormLayouts"
import UtilBackground from "../docs/UtilBackground"
import UtilBorder from "../docs/UtilBorder"
import UtilColors from "../docs/UtilColors"
import UtilDivider from "../docs/UtilDivider"
import UtilFlex from "../docs/UtilFlex"
import UtilSizing from "../docs/UtilSizing"
import UtilSpacing from "../docs/UtilSpacing"
import UtilOpacity from "../docs/UtilOpacity"
import UtilPosition from "../docs/UtilPosition"
import UtilTypography from "../docs/UtilTypography"
import UtilShadows from "../docs/UtilShadows"
import UtilExtras from "../docs/UtilExtras"
import ApexCharts from "../docs/ApexCharts"
import ChartJs from "../docs/ChartJs"
import MapLeaflet from "../docs/MapLeaflet"
import MapVector from "../docs/MapVector"
import IconRemix from "../docs/IconRemix"
import IconFeather from "../docs/IconFeather"

// Protected routes
import { AsginarAsignaciondeCartera, BuscarBahia, EditarEmbalaje, FiltrarProformas, SubMenu } from "../pages"
import { BuscarPicking } from "../pages"
import { CatalogoProductos, FiltrosCatalogosProductos, EmisionQR, Proforma } from "../pages"
import { SimpleMenu } from "../pages"

// Consultas e imformes
import { VtasDiasLocalidad, BcosDiasSaldos, BcosDiasSaldosDetail } from "../pages"

// Proceso de paletizacion
import {
  Paletizacion,
  BuscarPaletizacion,
  CrearPaletizacion,
  EjecutarPaletizacion,
  EjecutarBuscarPaletizacion,
  BuscarUbicacionPaletizacion,
  BuscarLotesPaletizacion,
} from "../pages"
// Banco de preguntas
import { BancosDePreguntas, CrearBancosDePreguntas, EditarBancosDePreguntas } from "../pages"

// Gestion de almacen - Procesos
import { GestionAlmacenProcesos, CrearGestionAlmacenProceso, EditarGestionAlmacenProceso } from "../pages"

// Formularios Procesos
import { FormulariosProcesos, CrearFormulario, EditarFormulario } from "../pages"
import IntegracionExterna from "../pages/IntegracionExterna"
import SolicitudEgreso from "../pages/SolicitudEgreso"
import SolicitudEgresoDetalle from "../pages/SolicitudEgresoDetalle"
import CuerpoProforma from "../pages/Proforma/components/EmisionProforma"

// Verificacion de Documental
import {
  VerificacionDocumental,
  BuscarVerificacionDocumental,
  FormulariosReadable,
  CrearVerificacionDocumental,
  Formularios,
} from "../pages"

// Descarga en cuarentena
import {
  DescargaCuarentena,
  CrearDescargaCuarentena,
  VerTodosProductos,
  BuscarDescargaCuarentena,
  VerTodosProductosReadable,
  VerTodosArticulosIngreso,
} from "../pages"

// Asignacion de Ubicacion
import {
  AsignacionUbicacion,
  CrearAsignacionUbicacion,
  CrearTodosIngresosReadableAsignacionUbicacion,
  CrearTodosArticulosIngresoAsignacionUbicacion,
  BuscarAsignacionUbicacion,
  BuscarTodosIngresosReadableAsignacionUbicacion,
  BuscarTodosArticulosIngresoAsignacionUbicacion,
  ActualizarAsignacionUbicacion,
  ActualizarTodosIngresosReadableAsignacionUbicacion,
  ActualizarTodosArticulosIngresoAsignacionUbicacion,
} from "../pages"

// Verificacion Quimico
import {
  VerificacionQuimico,
  CrearVerificacionQuimico,
  VerificarVerificacionQuimico,
  BuscarVerificacionQuimico,
  VerificadoVerificacionQuimico,
} from "../pages"

// Movilizacion Bahia
import { MovilizacionBahia, CrearMovilizacionBahia, MovilizarMovilizacionBahia } from "../pages"

// Verificacion de Codigo de Barras
import { VerificacionCodigoDeBarras } from "../pages"

// Solicitud de Ingreso
import { SolicitudDeIngreso, BuscarSolicitudDeIngreso, CrearSolicitudDeIngreso, VerSolicitudDeIngreso } from "../pages"

// Solicitud de Egreso
import { SolicitudDeEntrega, BuscarSolicitudEntrega, CrearSolicitudEntrega, VerSolicitudDeEntrega } from "../pages"
// Aprobacion de Solicitud de Entrega
import { AprobacionSolicitudEntrega, BuscarSolicitudDeEntrega, VerAprobacion } from "../pages"
// Zonas
import { Zonas, EditarZona, CrearZona } from "../pages"
// Pasillos
import { Pasillos, EditarPasillo, CrearPasillo } from "../pages"
// Posiciones
import { Posiciones, EditarPosicion, CrearPosicion } from "../pages"
// Niveles
import { Niveles, EditarNivel, CrearNivel } from "../pages"

// Picking Sugerido

import {
  PickingSugerido,
  PickingSugeridoCrear,
  PickingSugeridoBuscar,
  PickingSugeridoVer,
  VerProductosPicking,
} from "../pages"

// Picking
import { Picking } from "../pages"

// Power Bi
import { PowerBi } from "../pages"
// Embalajes
import { Embalajes, CrearEmbalaje } from "../pages"
import CrearPicking from "../pages/Picking/Crear"

// Tonos
import { Tonos, CrearTono, EditarTono } from "../pages"

// Motivos
import { Motivos, CrearMotivo, EditarMotivo } from "../pages"
// Acciones
import { Acciones, CrearAccion, EditarAccion } from "../pages"
// Empaques
import { Empaques, CrearEmpaque, DetalleEmpaque } from "../pages"
// Bahias
import { Bahias, CrearBahia, EditarBahia } from "../pages"
// Asociacion de bodegas a clientes
import { AsociacionBodegasCliente, AsociarBodegaCliente } from "../pages"

// Cierre de Picking
import { CierrePicking, CierrePickingCrear, CierrePickingVer } from "../pages"
import { AsociacionClientesProveedor, AsociarClienteProveedor } from "../pages"
import { AsociacionProductosAgencias, CrearAsociacionProdAgencias, BuscarAsociacion, EditarAsociacion } from "../pages"
// EgresoPicking
import { EgresoPicking, BuscarPickingEgreso, EgresoPickingVer, CrearEgreso } from "../pages"

// Visor errores Soho
import { VisorErroresSoho } from "../pages"

// Facturacion
import {
  FacturaDesdeArticulos,
  BuscarFacturaDesdeArticulos,
  CrearFacturaDesdeArticulos,
  EditarFacturaDesdeArticulos,
} from "../pages"

import { ProductosServicios } from "../pages"

// Administrador Pedidos Mostrador
import {
  AdministradorPedidosMostrador,
  CrearAdministradorPedidosMostrador,
  AdministradorPedidosMostradorBuscar,
  AdministradorPedidosMostradorBuscarCita,
  AdministradorPedidosMostradorEliminar,
  AdministradorPedidosMostradorActualizar,
  AdministradorPedidosMostradorActualizarCita,
} from "../pages"

// Vendedor Pedidos Mostrador
import {
  VendedorPedidosMostrador,
  CrearVendedorPedidosMostrador,
  CitaPedidosMostrador,
  VendedorPedidosMostradorBuscar,
  VendedorPedidosMostradorBuscarCita,
  VendedorPedidosMostradorEliminar,
  VendedorPedidosMostradorEliminarCita,
} from "../pages"

// Comisiones
import { Comisiones } from "../pages"

// Propinas
import { Propinas } from "../pages"

// Cambio de Clave
import { CambioClave } from "../pages"

// Orden de compra Gerencia Comercial
import {
  OCGerenciaAdquisiciones,
  OCGerenciaAdquisicionesCrear,
  OCGerenciaAdquisicionesCrearOrdenCompra,
} from "../pages"

// Aprobacion de solicitud de pago
import { AprobacionSolicitudPago, AprobacionSolicitudPagoCrear } from "../pages"

// Planifacion de labores
import { PlanificacionLabores, CrearPlanificacionLabores } from "../pages"
// Ejecucion de labores
import { EjecucionLabores, CrearEjecucionLabores, BuscarEjecucionLabores } from "../pages"

// Planificacion Vs Ejecucion de labores
import { PlanificacionVSEjecucionLabores } from "../pages"

// Ejecucion de Labores  //TODO
// import { EjecucionLabores, CrearEjecucionLabores } from "../pages"

// Planificacion VS Ejecucion de Labores //TODO
// import { PlanificacionVSEjecucionLabores, CrearPlanificacionVSEjecucionLabores } from "../pages"

// Creacion de Usuarios
import { CreacionUsuarios, CrearCreacionUsuarios, BuscarCreacionUsuarios, EditarCreacionUsuarios } from "../pages"

import { AccesoACompañiasYModulos, BuscarAccesoACompañiasYModulos } from "../pages"

import { AccesoAOpcionesPorModulos, BuscarAccesoAOpcionesPorModulos } from "../pages"

import { ActualizaClaveOlvidada } from "../pages"

import { ActualizaClaveFechaCaducidadLote } from "../pages"

// Banco de Tareas
import { BancoDeTareas, CrearBancoDeTareas, EditarBancoDeTareas } from "../pages"

// Procesos de Tarea
import { ProcesosTarea, CrearProcesosTarea, EditarProcesosTarea } from "../pages"

// Paquetes de Procesos de Tarea
import { PaquetesDeProcesoTareas, CrearPaquetesDeProcesoTareas, EditarPaquetesDeProcesoTareas } from "../pages"

// Planificacion de Tareas
import { PlanificacionDeTareas } from "../pages"

// Assignacion de Horarios a Usuarios
import {
  AsignacionHorariosAUsuarios,
  BuscarAsignacionHorariosAUsuarios,
  CrearAsignacionHorariosAUsuarios,
} from "../pages"

// Creación de clientes
import { CreacionClientes, CrearCreacionClientes, EditarCreacionClientes, BuscarCreacionClientes } from "../pages"

// Ejecucion de tareas
import { EjecucionTareas, CrearEjecucionTareas, BuscarEjecucionTareas } from "../pages"

// ConsultaDeCedulaEventos
import { ConsultaDeCedulaEventos } from "../pages"

// Acceso a localidades
import { AccesoALocalidades, AccesoALocalidadesBuscar } from "../pages"

// Tipos De Pedidos
import { ConsultaDeAsistencia } from "../pages"

// EmisionPedidoWeb (es la opcion del carrito)
import { EmisionPedidoWeb } from "../pages"

// Activacion De Predios
import {
  ActivacionDePredios,
  CrearCabeceraUnicaPredio,
  EditarCabeceraUnicaPredio,
  BuscarCabeceraUnicaPredio,
  CrearDetalleATitularidad,
  EditarDetalleATitularidad,
  BuscarDetalleATitularidad,
} from "../pages"

// Mantenedores Predios
import {
  TiposGravamen,
  CrearTiposGravamen,
  EditarTiposGravamen,
  TiposPredio,
  CrearTiposPredio,
  EditarTiposPredio,
  TitulosAdquisicion,
  CrearTituloAdquisicion,
  EditarTituloAdquisicion,
  BeneficiariosGravamen,
  CrearBeneficiariosGravamen,
  EditarBeneficiariosGravamen,
  CancelacionesGravamen,
  CrearCancelacionGravamen,
  EditarCancelacionGravamen,
  TiposCertificado,
  CrearTipoCertificado,
  EditarTipoCertificado,
} from "../pages"

import { TiemposEjecucionTareaResumen, ResumenProductividad, CargaDeTrabajo } from "../pages"

import {
  Compania,
  CrearCompania,
  EditarCompania,
  BuscarCompania,
  Localidad,
  CrearLocalidad,
  EditarLocalidad,
  BuscarLocalidad,
  TiposCliente,
  CrearTiposCliente,
  EditarTiposCliente,
  BuscarTiposCliente,
  TipoDocumento,
  CrearTipoDocumento,
  EditarTipoDocumento,
  Pais,
  CrearPais,
  EditarPais,
  Ciudad,
  CrearCiudad,
  EditarCiudad,
  Provincia,
  CrearProvincia,
  EditarProvincia,
  Parroquia,
  CrearParroquia,
  EditarParroquia,
  SectorComercialCliente,
  CrearSectorComercialCliente,
  EditarSectorComercialCliente,
  IntegradoresVentas,
  CrearIntegradoresVentas,
  EditarIntegradoresVentas,
  PlanesServicios,
  CrearPlanServicio,
  EditarPlanServicio,
  Iva,
  CrearIva,
  EditarIva,
  ImpuestosRetenciones,
  CrearImpuestoRetencion,
  EditarImpuestoRetencion,
} from "../pages"

// Cargos
import { Cargos, CrearCargo, EditarCargo } from "../pages"
import { TipodeContraCli, CrearTipodeContraCli, EditarTipodeContraCli } from "../pages"

// PPE TIPOS
import { TiposPPE, CrearTiposPPE, EditarTiposPPE } from "../pages"

// PPE SUBTIPOS
import { SubTiposPPE, CrearSubTiposPPE, EditarSubTiposPPE } from "../pages"

// PPE UBICACIONES
import { UbicacionesPPE, CrearUbicacionesPPE, EditarUbicacionesPPE } from "../pages"

// PPE CENTROS
import { CentrosPPE, CrearCentrosPPE, EditarCentrosPPE } from "../pages"

// PPE Emplazamientos
import { EmplazamientosPPE, CrearEmplazamientosPPE, EditarEmplazamientosPPE } from "../pages"

// PPE Custodios
import { CustodiosPPE, CrearCustodiosPPE, EditarCustodiosPPE } from "../pages"

// PPE Custodios
import { AltasPPE, CrearAltasPPE } from "../pages"

// PPE InventariosINV
import { InventariosINV, CrearInventariosINV, EditarInventariosINV } from "../pages"

// Balanzas
import { Balanzas, CrearBalanzas, EditarBalanzas } from "../pages"

// Pesajes
import { Pesajes, CrearPesajes, EditarPesajes } from "../pages"

// AsignaciondeCartera
import { AsignaciondeCartera, AsignarAsignaciondeCartera } from "../pages"

// TiposdeCompromiso
import { TiposdeCompromiso, CrearTiposdeCompromiso, EditarTiposdeCompromiso } from "../pages"

// GestiondeCartera
import { GestiondeCartera, DetalleGestiondeCartera } from "../pages"

// Agenda
import { Agenda, CrearAgenda, BuscarAgenda } from "../pages"

// TrasladoaDptoLegal
import { TrasladoaDptoLegal, EditarTrasladoaDptoLegal } from "../pages"

// DashboardCartera
import { DashboardCartera } from "../pages"

// ConsultadeCartera
import { ConsultadeCartera } from "../pages"

// Encuestas
import { Encuestas, CrearEncuestas, EditarEncuestas } from "../pages"

// AsigEncuestas
import { AsigEncuestas, AsignarAsigEncuestas } from "../pages"

// EjecEncuestas
import { EjecEncuestas, EjecutarEjecEncuestas } from "../pages"

// DashboardEncuesta
import { DashboardEncuesta } from "../pages"

// ControlElectoral\\
/// /cordinador
import { DashboardCordinador } from "../pages"
import { AsistenciaCordinador } from "../pages"
import { ReasigMesasCordinador } from "../pages"
import { AlertasSegCordinador } from "../pages"

// delegado
import { DashboardDelegado } from "../pages"
import { IngresoActaDelegado } from "../pages"
import { MisActasDelegado } from "../pages"
import { IncidenciaDelegado } from "../pages"
import { SincronizacionDelegado } from "../pages"

/// /cuarto de control
import { DashboardCenCom } from "../pages"
import { GeografiaElectoralCenCom } from "../pages"
import { AuditoriaActasCenCom } from "../pages"
import { ReportesExportacionLegalCenCom } from "../pages"

/// /RecintosElectorales
import { RecintosElectorales, CrearRecintoElectoral, EditarRecintoElectoral } from "../pages"

/// /JuntasReceptoras
import { JuntasReceptoras, CrearJuntasReceptoras, EditarJuntasReceptoras } from "../pages"

/// /Candidatos
import { Candidatos, CrearCandidatos, EditarCandidatos } from "../pages"

/// /DelegadosCordinadores
import { DelegadosCordinadores, CrearDelegadosCordinadores, EditarDelegadosCordinadores } from "../pages"

// LineasINV
import { LineasINV, CrearLineasINV, EditarLineasINV } from "../pages"

// MarcasINV
import { MarcasINV, CrearMarcasINV, EditarMarcasINV } from "../pages"

// MedidasINV
import { MedidasINV, CrearMedidasINV, EditarMedidasINV } from "../pages"

// PresentacionesINV
import { PresentacionesINV, CrearPresentacionesINV, EditarPresentacionesINV } from "../pages"

// Transportistas
import { Transportistas, CrearTransportistas, EditarTransportistas } from "../pages"

// ServiciosNDNC
import { ServiciosNDNC, CrearServiciosNDNC, EditarServiciosNDNC } from "../pages"

// Bodegas
import { Bodegas, CrearBodegas, EditarBodegas } from "../pages"

// Colores
import { Colores, CrearColores, EditarColores } from "../pages"

// Regiones
import { Regiones, CrearRegiones, EditarRegiones } from "../pages"

// TipoSolicitud
import { TipoSolicitud, CrearTipoSolicitud, EditarTipoSolicitud } from "../pages"

// TipoMotivo
import { TipoMotivo, CrearTipoMotivo, EditarTipoMotivo } from "../pages"

// TipoTransacciones
import { TipoTransacciones, CrearTipoTransacciones, EditarTipoTransacciones } from "../pages"

// AsignacionTipoSolaUsu
import { AsignacionTipoSolaUsu } from "../pages"

// CatalogodeProductos
import {
  CatalogodeProductos,
  CrearCatalogodeProductos,
  EditarCatalogodeProductos,
  BuscarCatalogodeProductos,
} from "../pages"

// JefedeProductos
import { JefedeProductos, CrearJefedeProductos, EditarJefedeProductos } from "../pages"

// CrearSolicitudIngEgr
import { CrearSolicitudIngEgr, CrearCrearSolicitudIngEgr, EditarCrearSolicitudIngEgr } from "../pages"

// AprobacionSolIngEgr
import { AprobacionSolIngEgr, EditarAprobacionSolIngEgr } from "../pages"

// IngEgrporSolicitud
import { IngEgrporSolicitud, EditarIngEgrporSolicitud, BuscarIngEgrporSolicitud } from "../pages"

// ConsultasCobrosAplA
import { ConsultasCobrosAplA, DetalleConsultasCobrosAplA } from "../pages"

// TomaFisica
import { TomaFisica, CrearTomaFisica, DetalleTomaFisica, BuscarTomaFisica } from "../pages"

// TomaFisicaMovil
import { TomaFisicaMovil, CrearTomaFisicaMovil } from "../pages"

// ResumenProductosbodegas
import { ResumenProductosbodegas } from "../pages"

// RetencionMasiva
import { RetencionMasiva } from "../pages"

const protectedRoutes = [
  { path: "Submenu/:label/:id", element: <SubMenu /> },
  { path: "dashboard/Emisión QR / Barras", element: <EmisionQR /> },
  { path: "dashboard/Proforma/:id", element: <Proforma /> },
  { path: "dashboard/Proformas / Pedidos", element: <FiltrarProformas /> },
  {
    path: "dashboard/Proformas / EmisionProforma",
    element: <CuerpoProforma />,
  },

  { path: "dashboard/Creacion de Catalogos", element: <CatalogoProductos /> },
  {
    path: "dashboard/Creacion de Catalogos/Filtros",
    element: <FiltrosCatalogosProductos />,
  },
  { path: "dashboard/VtasDiasLocalidad", element: <VtasDiasLocalidad /> },
  { path: "dashboard/BcosDiasSaldos", element: <BcosDiasSaldos /> },
  {
    path: "dashboard/BcosDiasSaldos/:bcocodigo",
    element: <BcosDiasSaldosDetail />,
  },
  { path: "dashboard/Paletizacion", element: <Paletizacion /> },
  { path: "dashboard/Paletizacion", element: <Paletizacion /> },
  { path: "dashboard/Paletizacion/Crear", element: <CrearPaletizacion /> },
  {
    path: "dashboard/Paletizacion/Crear/Ejecutar",
    element: <EjecutarPaletizacion />,
  },
  { path: "dashboard/Paletizacion/Buscar", element: <BuscarPaletizacion /> },
  {
    path: "dashboard/Paletizacion/Buscar/Ejecutar",
    element: <EjecutarBuscarPaletizacion />,
  },
  {
    path: "dashboard/Paletizacion/Buscar/Ejecutar/:idArticulo",
    element: <BuscarUbicacionPaletizacion />,
  },
  {
    path: "dashboard/Paletizacion/Buscar/Ejecutar/:idArticulo/:numLotes",
    element: <BuscarLotesPaletizacion />,
  },
  { path: "dashboard/BancoDePreguntas", element: <BancosDePreguntas /> },

  {
    path: "dashboard/BancoDePreguntas/crear",
    element: <CrearBancosDePreguntas />,
  },
  {
    path: "dashboard/BancoDePreguntas/editar/:id",
    element: <EditarBancosDePreguntas />,
  },
  {
    path: "dashboard/Procesos",
    element: <GestionAlmacenProcesos />,
  },
  {
    path: "dashboard/Procesos",
    element: <GestionAlmacenProcesos />,
  },
  {
    path: "dashboard/Procesos/crear",
    element: <CrearGestionAlmacenProceso />,
  },
  {
    path: "dashboard/Procesos/editar/:proceso",
    element: <EditarGestionAlmacenProceso />,
  },
  {
    path: "dashboard/FormulariosParaProcesos",
    element: <FormulariosProcesos />,
  },
  {
    path: "dashboard/FormulariosParaProcesos/crear",
    element: <CrearFormulario />,
  },
  {
    path: "dashboard/FormulariosParaProcesos/editar/:formularioID",
    element: <EditarFormulario />,
  },
  { path: "dashboard/IntegracionExterna", element: <IntegracionExterna /> },
  { path: "dashboard/SolicitudEgreso", element: <SolicitudEgreso /> },
  { path: "dashboard/SolicitudDeIngreso", element: <SolicitudDeIngreso /> },
  { path: "dashboard/SolicitudDeIngreso/buscar", element: <BuscarSolicitudDeIngreso /> },
  { path: "dashboard/SolicitudDeIngreso/crear", element: <CrearSolicitudDeIngreso /> },
  { path: "dashboard/SolicitudDeIngreso/buscar/editar/solicitudes", element: <VerSolicitudDeIngreso /> },
  { path: "dashboard/SolicitudDeEntrega", element: <SolicitudDeEntrega /> },
  { path: "dashboard/SolicitudDeEntrega/Buscar", element: <BuscarSolicitudEntrega /> },
  { path: "dashboard/SolicitudDeEntrega/Crear", element: <CrearSolicitudEntrega /> },
  { path: "dashboard/SolicitudDeEntrega/buscar/editar/solicitudes", element: <VerSolicitudDeEntrega /> },
  {
    path: "dashboard/AprobacionSolicitudEntrega",
    element: <AprobacionSolicitudEntrega />,
  },
  {
    path: "dashboard/AprobacionSolicitudEntrega/Buscar",
    element: <BuscarSolicitudDeEntrega />,
  },
  {
    path: "dashboard/AprobacionSolicitudEntrega/buscar/Aprobar",
    element: <VerAprobacion />,
  },
  {
    path: "dashboard/SolicitudEgresoDetalle/:id",
    element: <SolicitudEgresoDetalle />,
  },
  {
    path: "dashboard/verificacionDocumental",
    element: <VerificacionDocumental />,
  },
  {
    path: "dashboard/verificacionDocumental/Buscar",
    element: <BuscarVerificacionDocumental />,
  },
  {
    path: "dashboard/verificacionDocumental/Buscar/Formularios",
    element: <FormulariosReadable />,
  },
  {
    path: "dashboard/verificacionDocumental/Crear",
    element: <CrearVerificacionDocumental />,
  },
  {
    path: "dashboard/verificacionDocumental/Crear/Formularios",
    element: <Formularios />,
  },
  {
    path: "dashboard/descargaCuarentena",
    element: <DescargaCuarentena />,
  },
  {
    path: "dashboard/descargaCuarentena/crear",
    element: <CrearDescargaCuarentena />,
  },
  {
    path: "dashboard/descargaCuarentena/crear/ver",
    element: <VerTodosProductos />,
  },
  {
    path: "dashboard/descargaCuarentena/buscar",
    element: <BuscarDescargaCuarentena />,
  },
  {
    path: "dashboard/descargaCuarentena/buscar/ver",
    element: <VerTodosProductosReadable />,
  },
  {
    path: "dashboard/descargaCuarentena/buscar/ver/articulos",
    element: <VerTodosArticulosIngreso />,
  },
  {
    path: "dashboard/asignacionUbicacion",
    element: <AsignacionUbicacion />,
  },
  // {
  //   path: "dashboard/asignacionUbicacion/crear",
  //   // element: <CrearAsignacionUbicacion />,  #No se usa se redirecciona a asignacionUbicacion/crear/ver
  // },
  {
    path: "dashboard/asignacionUbicacion/crear/ver",
    element: <CrearTodosIngresosReadableAsignacionUbicacion />,
  },
  {
    path: "dashboard/asignacionUbicacion/crear/ver/articulos",
    element: <CrearTodosArticulosIngresoAsignacionUbicacion />,
  },
  {
    path: "dashboard/asignacionUbicacion/buscar",
    element: <BuscarAsignacionUbicacion />,
  },
  {
    path: "dashboard/asignacionUbicacion/buscar/ver",
    element: <BuscarTodosIngresosReadableAsignacionUbicacion />,
  },
  {
    path: "dashboard/asignacionUbicacion/buscar/ver/articulos",
    element: <BuscarTodosArticulosIngresoAsignacionUbicacion />,
  },
  // {
  //   path: "dashboard/asignacionUbicacion/actualizar",
  //   element: <ActualizarAsignacionUbicacion />, #No se usa se redirecciona a asignacionUbicacion/actualizar/ver
  // },
  {
    path: "dashboard/asignacionUbicacion/actualizar/ver",
    element: <ActualizarTodosIngresosReadableAsignacionUbicacion />,
  },
  {
    path: "dashboard/asignacionUbicacion/actualizar/ver/articulos",
    element: <ActualizarTodosArticulosIngresoAsignacionUbicacion />,
  },
  {
    path: "dashboard/verificacionQuimico",
    element: <VerificacionQuimico />,
  },
  {
    path: "dashboard/verificacionQuimico/crear",
    element: <CrearVerificacionQuimico />,
  },
  {
    path: "dashboard/verificacionQuimico/crear/verificar",
    element: <VerificarVerificacionQuimico />,
  },
  {
    path: "dashboard/verificacionQuimico/buscar",
    element: <BuscarVerificacionQuimico />,
  },
  {
    path: "dashboard/verificacionQuimico/buscar/verificado",
    element: <VerificadoVerificacionQuimico />,
  },
  {
    path: "dashboard/movilizacionBahia",
    element: <MovilizacionBahia />,
  },
  {
    path: "dashboard/movilizacionBahia/crear",
    element: <CrearMovilizacionBahia />,
  },
  {
    path: "dashboard/movilizacionBahia/crear/movilizar",
    element: <MovilizarMovilizacionBahia />,
  },

  {
    path: "dashboard/verificacionCodigoDeBarras",
    element: <VerificacionCodigoDeBarras />,
  },
  {
    path: "dashboard/Zonas",
    element: <Zonas />,
  },
  {
    path: "dashboard/Zonas/editar/:id",
    element: <EditarZona />,
  },
  {
    path: "dashboard/Zonas/crear",
    element: <CrearZona />,
  },
  {
    path: "dashboard/Pasillos",
    element: <Pasillos />,
  },
  {
    path: "dashboard/Pasillos/editar/:id",
    element: <EditarPasillo />,
  },
  {
    path: "dashboard/Pasillos/crear",
    element: <CrearPasillo />,
  },
  {
    path: "dashboard/Posiciones",
    element: <Posiciones />,
  },
  {
    path: "dashboard/Posiciones/editar/:id",
    element: <EditarPosicion />,
  },
  {
    path: "dashboard/Posiciones/crear",
    element: <CrearPosicion />,
  },
  {
    path: "dashboard/Niveles",
    element: <Niveles />,
  },
  {
    path: "dashboard/Niveles/editar/:id",
    element: <EditarNivel />,
  },
  {
    path: "dashboard/Niveles/crear",
    element: <CrearNivel />,
  },
  {
    path: "dashboard/PickingSugerido",
    element: <PickingSugerido />,
  },
  {
    path: "dashboard/PickingSugerido/crear",
    element: <PickingSugeridoCrear />,
  },
  {
    path: "dashboard/PickingSugerido/buscar",
    element: <PickingSugeridoBuscar />,
  },
  {
    path: "dashboard/PickingSugerido/buscar/ver",
    element: <PickingSugeridoVer />,
  },
  {
    path: "dashboard/Picking",
    element: <Picking />,
  },
  {
    path: "dashboard/Picking/buscar",
    element: <BuscarPicking />,
  },
  {
    path: "dashboard/Picking/crear",
    element: <CrearPicking />,
  },
  {
    path: "dashboard/Picking/crear/productos",
    element: <VerProductosPicking />,
  },
  {
    path: "dashboard/:page/PBI",
    element: <PowerBi />,
  },
  {
    path: "dashboard/Embalajes",
    element: <Embalajes />,
  },
  {
    path: "dashboard/Embalajes/crear",
    element: <CrearEmbalaje />,
  },
  {
    path: "dashboard/Embalajes/editar/:id",
    element: <EditarEmbalaje />,
  },
  {
    path: "dashboard/Tonos",
    element: <Tonos />,
  },
  {
    path: "dashboard/Tonos/crear",
    element: <CrearTono />,
  },
  {
    path: "dashboard/Tonos/editar/:id",
    element: <EditarTono />,
  },
  {
    path: "dashboard/Motivos",
    element: <Motivos />,
  },
  {
    path: "dashboard/Motivos/crear",
    element: <CrearMotivo />,
  },
  {
    path: "dashboard/Motivos/editar/:id",
    element: <EditarMotivo />,
  },
  {
    path: "dashboard/Acciones",
    element: <Acciones />,
  },
  {
    path: "dashboard/Acciones/crear",
    element: <CrearAccion />,
  },
  {
    path: "dashboard/Acciones/editar/:id",
    element: <EditarAccion />,
  },
  {
    path: "dashboard/Empaques",
    element: <Empaques />,
  },
  {
    path: "dashboard/Empaques/crear",
    element: <CrearEmpaque />,
  },
  {
    path: "dashboard/Empaques/detalle/:id",
    element: <DetalleEmpaque />,
  },
  {
    path: "dashboard/Bahias",
    element: <Bahias />,
  },
  {
    path: "dashboard/Bahias/buscar",
    element: <BuscarBahia />,
  },
  {
    path: "dashboard/Bahias/crear",
    element: <CrearBahia />,
  },
  { path: "dashboard/Bahias/buscar/editar/bahias", element: <EditarBahia /> },
  {
    path: "dashboard/AsociacionBodegasCliente",
    element: <AsociacionBodegasCliente />,
  },
  {
    path: "dashboard/AsociacionBodegasCliente/asociar",
    element: <AsociarBodegaCliente />,
  },
  {
    path: "dashboard/CierrePicking",
    element: <CierrePicking />,
  },
  {
    path: "dashboard/CierrePicking/Crear",
    element: <CierrePickingCrear />,
  },
  {
    path: "dashboard/CierrePicking/Crear/Ver",
    element: <CierrePickingVer />,
  },
  {
    path: "dashboard/AsociacionClientesProveedor",
    element: <AsociacionClientesProveedor />,
  },
  {
    path: "dashboard/AsociacionClientesProveedor/asociar",
    element: <AsociarClienteProveedor />,
  },
  {
    path: "dashboard/AsociacionProdAgencias",
    element: <AsociacionProductosAgencias />,
  },
  {
    path: "dashboard/AsociacionProdAgencias/crear",
    element: <CrearAsociacionProdAgencias />,
  },
  {
    path: "dashboard/AsociacionProdAgencias/buscar",
    element: <BuscarAsociacion />,
  },
  { path: "dashboard/AsociacionProdAgencias/buscar/editar/Asociaciones", element: <EditarAsociacion /> },
  { path: "dashboard/EgresoPicking", element: <EgresoPicking /> },
  { path: "dashboard/EgresoPicking/buscar", element: <BuscarPickingEgreso /> },
  { path: "dashboard/EgresoPicking/buscar/ver", element: <EgresoPickingVer /> },
  { path: "dashboard/EgresoPicking/crear", element: <CrearEgreso /> },
  {
    path: "dashboard/visorError",
    element: <VisorErroresSoho />,
  },
  {
    path: "dashboard/FacturaDesdeArticulos",
    element: <FacturaDesdeArticulos />,
  },
  {
    path: "dashboard/FacturaDesdeArticulos/buscar",
    element: <BuscarFacturaDesdeArticulos />,
  },
  {
    path: "dashboard/FacturaDesdeArticulos/crear",
    element: <CrearFacturaDesdeArticulos />,
  },
  {
    path: "dashboard/FacturaDesdeArticulos/editar",
    element: <EditarFacturaDesdeArticulos />,
  },

  { path: "dashboard/ProductosServicios", element: <ProductosServicios /> },
  {
    path: "dashboard/RecepcionTemp",
    element: <AdministradorPedidosMostrador />,
  },
  {
    path: "dashboard/RecepcionTemp/crear",
    element: <CrearAdministradorPedidosMostrador />,
  },
  {
    path: "dashboard/RecepcionTemp/buscar",
    element: <AdministradorPedidosMostradorBuscar />,
  },
  {
    path: "dashboard/RecepcionTemp/buscar/cita",
    element: <AdministradorPedidosMostradorBuscarCita />,
  },
  {
    path: "dashboard/RecepcionTemp/eliminar",
    element: <AdministradorPedidosMostradorEliminar />,
  },
  {
    path: "dashboard/RecepcionTemp/actualizar",
    element: <AdministradorPedidosMostradorActualizar />,
  },
  {
    path: "dashboard/RecepcionTemp/actualizar/cita",
    element: <AdministradorPedidosMostradorActualizarCita />,
  },

  {
    path: "dashboard/VendedorTemp",
    element: <VendedorPedidosMostrador />,
  },
  {
    path: "dashboard/VendedorTemp/crear",
    element: <CrearVendedorPedidosMostrador />,
  },
  {
    path: "dashboard/VendedorTemp/crear/cita",
    element: <CitaPedidosMostrador />,
  },
  {
    path: "dashboard/VendedorTemp/buscar",
    element: <VendedorPedidosMostradorBuscar />,
  },
  {
    path: "dashboard/VendedorTemp/buscar/cita",
    element: <VendedorPedidosMostradorBuscarCita />,
  },
  {
    path: "dashboard/VendedorTemp/eliminar",
    element: <VendedorPedidosMostradorEliminar />,
  },
  {
    path: "dashboard/VendedorTemp/eliminar/cita",
    element: <VendedorPedidosMostradorEliminarCita />,
  },
  {
    path: "dashboard/Comisiones",
    element: <Comisiones />,
  },
  {
    path: "dashboard/Propinas",
    element: <Propinas />,
  },
  {
    path: "dashboard/CambioClave",
    element: <CambioClave />,
  },
  {
    path: "dashboard/OCGerenciaAdquisiciones",
    element: <OCGerenciaAdquisiciones />,
  },
  {
    path: "dashboard/OCGerenciaAdquisiciones/crear",
    element: <OCGerenciaAdquisicionesCrear />,
  },
  {
    path: "dashboard/OCGerenciaAdquisiciones/crear/ordenCompra",
    element: <OCGerenciaAdquisicionesCrearOrdenCompra />,
  },
  {
    path: "dashboard/AprobacionSolicitudPago",
    element: <AprobacionSolicitudPago />,
  },
  {
    path: "dashboard/AprobacionSolicitudPago/crear",
    element: <AprobacionSolicitudPagoCrear />,
  },
  {
    path: "dashboard/PlanificacionLabores",
    element: <PlanificacionLabores />,
  },
  {
    path: "dashboard/PlanificacionLabores/crear",
    element: <CrearPlanificacionLabores />,
  },
  {
    path: "dashboard/CreacionUsuarios",
    element: <CreacionUsuarios />,
  },
  {
    path: "dashboard/CreacionUsuarios/crear",
    element: <CrearCreacionUsuarios />,
  },
  {
    path: "dashboard/CreacionUsuarios/buscar",
    element: <BuscarCreacionUsuarios />,
  },
  {
    path: "dashboard/CreacionUsuarios/editar",
    element: <EditarCreacionUsuarios />,
  },

  {
    path: "dashboard/EjecucionLabores",
    element: <EjecucionLabores />,
  },
  {
    path: "dashboard/EjecucionLabores/crear",
    element: <CrearEjecucionLabores />,
  },
  { path: "dashboard/EjecucionLabores/buscar", element: <BuscarEjecucionLabores /> },

  { path: "dashboard/PlanificacionVSEjecucionLabores", element: <PlanificacionVSEjecucionLabores /> },

  { path: "dashboard/AccesoACompañiasYModulos", element: <AccesoACompañiasYModulos /> },
  { path: "dashboard/AccesoACompañiasYModulos/buscar", element: <BuscarAccesoACompañiasYModulos /> },
  { path: "dashboard/AccesoAOpcionesPorModulos", element: <AccesoAOpcionesPorModulos /> },
  { path: "dashboard/AccesoAOpcionesPorModulos/buscar", element: <BuscarAccesoAOpcionesPorModulos /> },
  { path: "dashboard/ActualizaClaveOlvidada", element: <ActualizaClaveOlvidada /> },
  { path: "dashboard/ActualizaClaveFechaCaducidadLote", element: <ActualizaClaveFechaCaducidadLote /> },
  {
    path: "dashboard/BancoDeTareas",
    element: <BancoDeTareas />,
  },
  { path: "dashboard/BancoDeTareas/crear", element: <CrearBancoDeTareas /> },
  { path: "dashboard/BancoDeTareas/editar/:id", element: <EditarBancoDeTareas /> },
  {
    path: "dashboard/ProcesosTarea",
    element: <ProcesosTarea />,
  },
  { path: "dashboard/ProcesosTarea/crear", element: <CrearProcesosTarea /> },
  { path: "dashboard/ProcesosTarea/editar/:proceso", element: <EditarProcesosTarea /> },
  {
    path: "dashboard/PaquetesDeProcesoTareas",
    element: <PaquetesDeProcesoTareas />,
  },
  { path: "dashboard/PaquetesDeProcesoTareas/crear", element: <CrearPaquetesDeProcesoTareas /> },
  { path: "dashboard/PaquetesDeProcesoTareas/editar/:formularioID", element: <EditarPaquetesDeProcesoTareas /> },

  {
    path: "dashboard/PlanificacionTareas",
    element: <PlanificacionDeTareas />,
  },
  {
    path: "dashboard/AsignacionHorariosAUsuarios",
    element: <AsignacionHorariosAUsuarios />,
  },
  { path: "dashboard/AsignacionHorariosAUsuarios/buscar", element: <BuscarAsignacionHorariosAUsuarios /> },

  { path: "dashboard/AsignacionHorariosAUsuarios/crear", element: <CrearAsignacionHorariosAUsuarios /> },
  {
    path: "dashboard/CreacionClientes",
    element: <CreacionClientes />,
  },
  {
    path: "dashboard/CreacionClientes/crear",
    element: <CrearCreacionClientes />,
  },
  {
    path: "dashboard/CreacionClientes/buscar",
    element: <BuscarCreacionClientes />,
  },
  {
    path: "dashboard/CreacionClientes/editar",
    element: <EditarCreacionClientes />,
  },

  {
    path: "dashboard/EjecucionTareas",
    element: <EjecucionTareas />,
  },
  {
    path: "dashboard/EjecucionTareas/crear",
    element: <CrearEjecucionTareas />,
  },
  {
    path: "dashboard/EjecucionTareas/buscar",
    element: <BuscarEjecucionTareas />,
  },
  {
    path: "dashboard/ConsultaDeCedulaEventos",
    element: <ConsultaDeCedulaEventos />,
  },
  {
    path: "dashboard/AccesoALocalidades",
    element: <AccesoALocalidades />,
  },
  {
    path: "dashboard/AccesoALocalidades/buscar",
    element: <AccesoALocalidadesBuscar />,
  },
  {
    path: "dashboard/ConsultaDeAsistencia",
    element: <ConsultaDeAsistencia />,
  },
  {
    path: "dashboard/EmisionPedidoWeb",
    element: <EmisionPedidoWeb />,
  },

  {
    path: "dashboard/ActivacionDePredios",
    element: <ActivacionDePredios />,
  },

  {
    path: "dashboard/ActivacionDePredios/crear",
    element: <CrearCabeceraUnicaPredio />,
  },

  {
    path: "dashboard/ActivacionDePredios/editar",
    element: <EditarCabeceraUnicaPredio />,
  },
  {
    path: "dashboard/ActivacionDePredios/buscar",
    element: <BuscarCabeceraUnicaPredio />,
  },

  {
    path: "dashboard/ActivacionDePredios/crearDetalleA",
    element: <CrearDetalleATitularidad />,
  },

  {
    path: "dashboard/ActivacionDePredios/editarDetalleA",
    element: <EditarDetalleATitularidad />,
  },
  {
    path: "dashboard/ActivacionDePredios/buscarDetalleA",
    element: <BuscarDetalleATitularidad />,
  },
  {
    path: "dashboard/TiposDeGravamenes",
    element: <TiposGravamen />,
  },
  {
    path: "dashboard/TiposDeGravamenes/crear",
    element: <CrearTiposGravamen />,
  },
  {
    path: "dashboard/TiposDeGravamenes/editar",
    element: <EditarTiposGravamen />,
  },
  {
    path: "dashboard/TiposDePredios",
    element: <TiposPredio />,
  },
  {
    path: "dashboard/TiposDePredios/crear",
    element: <CrearTiposPredio />,
  },
  {
    path: "dashboard/TiposDePredios/editar",
    element: <EditarTiposPredio />,
  },
  {
    path: "dashboard/TitulosDePredios",
    element: <TitulosAdquisicion />,
  },
  {
    path: "dashboard/TitulosDePredios/crear",
    element: <CrearTituloAdquisicion />,
  },
  {
    path: "dashboard/TitulosDePredios/editar",
    element: <EditarTituloAdquisicion />,
  },
  {
    path: "dashboard/BeneficiariosDeGravamenes",
    element: <BeneficiariosGravamen />,
  },
  {
    path: "dashboard/BeneficiariosDeGravamenes/crear",
    element: <CrearBeneficiariosGravamen />,
  },
  {
    path: "dashboard/BeneficiariosDeGravamenes/editar",
    element: <EditarBeneficiariosGravamen />,
  },
  {
    path: "dashboard/CancelacionesDeGravamenes",
    element: <CancelacionesGravamen />,
  },
  {
    path: "dashboard/CancelacionesDeGravamenes/crear",
    element: <CrearCancelacionGravamen />,
  },
  {
    path: "dashboard/CancelacionesDeGravamenes/editar",
    element: <EditarCancelacionGravamen />,
  },
  {
    path: "dashboard/TiposDeCertificado",
    element: <TiposCertificado />,
  },
  {
    path: "dashboard/TiposDeCertificado/crear",
    element: <CrearTipoCertificado />,
  },
  {
    path: "dashboard/TiposDeCertificado/editar",
    element: <EditarTipoCertificado />,
  },
  {
    path: "dashboard/TiemposEjecucionTareaResumen",
    element: <TiemposEjecucionTareaResumen />,
  },
  {
    path: "dashboard/ResumenProductividad",
    element: <ResumenProductividad />,
  },
  {
    path: "dashboard/CargaDeTrabajo",
    element: <CargaDeTrabajo />,
  },

  {
    path: "dashboard/Compania",
    element: <Compania />,
  },
  {
    path: "dashboard/Compania/crear",
    element: <CrearCompania />,
  },
  {
    path: "dashboard/Compania/editar",
    element: <EditarCompania />,
  },
  {
    path: "dashboard/Compania/buscar",
    element: <BuscarCompania />,
  },
  {
    path: "dashboard/Localidad",
    element: <Localidad />,
  },
  {
    path: "dashboard/Localidad/crear",
    element: <CrearLocalidad />,
  },
  {
    path: "dashboard/Localidad/editar",
    element: <EditarLocalidad />,
  },
  {
    path: "dashboard/Localidad/buscar",
    element: <BuscarLocalidad />,
  },
  {
    path: "dashboard/TiposDeCliente",
    element: <TiposCliente />,
  },
  {
    path: "dashboard/TiposDeCliente/crear",
    element: <CrearTiposCliente />,
  },
  {
    path: "dashboard/TiposDeCliente/editar",
    element: <EditarTiposCliente />,
  },
  {
    path: "dashboard/TiposDeCliente/buscar",
    element: <BuscarTiposCliente />,
  },
  {
    path: "dashboard/TipoDeDocumento",
    element: <TipoDocumento />,
  },
  {
    path: "dashboard/TipoDeDocumento/crear",
    element: <CrearTipoDocumento />,
  },
  {
    path: "dashboard/TipoDeDocumento/editar",
    element: <EditarTipoDocumento />,
  },
  {
    path: "dashboard/Pais",
    element: <Pais />,
  },
  {
    path: "dashboard/Pais/crear",
    element: <CrearPais />,
  },
  {
    path: "dashboard/Pais/editar",
    element: <EditarPais />,
  },
  {
    path: "dashboard/Ciudad",
    element: <Ciudad />,
  },
  {
    path: "dashboard/Ciudad/crear",
    element: <CrearCiudad />,
  },
  {
    path: "dashboard/Ciudad/editar",
    element: <EditarCiudad />,
  },
  {
    path: "dashboard/Provincia",
    element: <Provincia />,
  },
  {
    path: "dashboard/Provincia/crear",
    element: <CrearProvincia />,
  },
  {
    path: "dashboard/Provincia/editar",
    element: <EditarProvincia />,
  },
  {
    path: "dashboard/Parroquia",
    element: <Parroquia />,
  },
  {
    path: "dashboard/Parroquia/crear",
    element: <CrearParroquia />,
  },
  {
    path: "dashboard/Parroquia/editar",
    element: <EditarParroquia />,
  },
  {
    path: "dashboard/SectorComercialCliente",
    element: <SectorComercialCliente />,
  },
  {
    path: "dashboard/SectorComercialCliente/crear",
    element: <CrearSectorComercialCliente />,
  },
  {
    path: "dashboard/SectorComercialCliente/editar",
    element: <EditarSectorComercialCliente />,
  },
  {
    path: "dashboard/IntegradoresVentas",
    element: <IntegradoresVentas />,
  },
  {
    path: "dashboard/IntegradoresVentas/crear",
    element: <CrearIntegradoresVentas />,
  },
  {
    path: "dashboard/IntegradoresVentas/editar",
    element: <EditarIntegradoresVentas />,
  },
  {
    path: "dashboard/PlanesServicios",
    element: <PlanesServicios />,
  },
  {
    path: "dashboard/PlanesServicios/crear",
    element: <CrearPlanServicio />,
  },
  {
    path: "dashboard/PlanesServicios/editar",
    element: <EditarPlanServicio />,
  },
  {
    path: "dashboard/IVA",
    element: <Iva />,
  },
  {
    path: "dashboard/IVA/crear",
    element: <CrearIva />,
  },
  {
    path: "dashboard/IVA/editar",
    element: <EditarIva />,
  },
  {
    path: "dashboard/impuestosRetenciones",
    element: <ImpuestosRetenciones />,
  },
  {
    path: "dashboard/impuestosRetenciones/crear",
    element: <CrearImpuestoRetencion />,
  },
  {
    path: "dashboard/impuestosRetenciones/editar",
    element: <EditarImpuestoRetencion />,
  },
  {
    path: "dashboard/Cargos",
    element: <Cargos />,
  },
  {
    path: "dashboard/Cargos",
    element: <Cargos />,
  },
  {
    path: "dashboard/Cargos/crear",
    element: <CrearCargo />,
  },
  {
    path: "dashboard/Cargos/editar",
    element: <EditarCargo />,
  },

  {
    path: "dashboard/TipodeContraCli",
    element: <TipodeContraCli />,
  },
  {
    path: "dashboard/TipodeContraCli/crear",
    element: <CrearTipodeContraCli />,
  },
  {
    path: "dashboard/TipodeContraCli/editar",
    element: <EditarTipodeContraCli />,
  },

  // PPE TIPOS
  {
    path: "dashboard/TiposPPE",
    element: <TiposPPE />,
  },
  {
    path: "dashboard/TiposPPE/crear",
    element: <CrearTiposPPE />,
  },
  {
    path: "dashboard/TiposPPE/editar",
    element: <EditarTiposPPE />,
  },
  // PPE SUBTIPOS
  {
    path: "dashboard/SubTiposPPE",
    element: <SubTiposPPE />,
  },
  {
    path: "dashboard/SubTiposPPE/crear",
    element: <CrearSubTiposPPE />,
  },
  {
    path: "dashboard/SubTiposPPE/editar",
    element: <EditarSubTiposPPE />,
  },
  // PPE UBICACIONES
  {
    path: "dashboard/UbicacionesPPE",
    element: <UbicacionesPPE />,
  },
  {
    path: "dashboard/UbicacionesPPE/crear",
    element: <CrearUbicacionesPPE />,
  },
  {
    path: "dashboard/UbicacionesPPE/editar",
    element: <EditarUbicacionesPPE />,
  },

  // PPE Centros
  {
    path: "dashboard/CentrosPPE",
    element: <CentrosPPE />,
  },
  {
    path: "dashboard/CentrosPPE/crear",
    element: <CrearCentrosPPE />,
  },
  {
    path: "dashboard/CentrosPPE/editar",
    element: <EditarCentrosPPE />,
  },

  // PPE Emplazamientos
  {
    path: "dashboard/EmplazamientosPPE",
    element: <EmplazamientosPPE />,
  },
  {
    path: "dashboard/EmplazamientosPPE/crear",
    element: <CrearEmplazamientosPPE />,
  },
  {
    path: "dashboard/EmplazamientosPPE/editar",
    element: <EditarEmplazamientosPPE />,
  },

  // PPE Custodios
  {
    path: "dashboard/CustodiosPPE",
    element: <CustodiosPPE />,
  },
  {
    path: "dashboard/CustodiosPPE/crear",
    element: <CrearCustodiosPPE />,
  },
  {
    path: "dashboard/CustodiosPPE/editar",
    element: <EditarCustodiosPPE />,
  },

  // InventariosINV
  {
    path: "dashboard/InventariosINV",
    element: <InventariosINV />,
  },
  {
    path: "dashboard/InventariosINV/crear",
    element: <CrearInventariosINV />,
  },
  {
    path: "dashboard/InventariosINV/editar",
    element: <EditarInventariosINV />,
  },

  // PPE Altas
  {
    path: "dashboard/AltasPPE",
    element: <AltasPPE />,
  },
  {
    path: "dashboard/AltasPPE/crear",
    element: <CrearAltasPPE />,
  },

  // Balanzas
  {
    path: "dashboard/Balanzas",
    element: <Balanzas />,
  },
  {
    path: "dashboard/Balanzas/crear",
    element: <CrearBalanzas />,
  },
  {
    path: "dashboard/Balanzas/editar",
    element: <EditarBalanzas />,
  },

  // Pesajes
  {
    path: "dashboard/Pesajes",
    element: <Pesajes />,
  },
  {
    path: "dashboard/Pesajes/crear",
    element: <CrearPesajes />,
  },
  {
    path: "dashboard/Pesajes/editar",
    element: <EditarPesajes />,
  },

  // AsignaciondeCartera
  {
    path: "dashboard/AsignaciondeCartera",
    element: <AsignaciondeCartera />,
  },
  {
    path: "dashboard/AsignaciondeCartera/Asignar",
    element: <AsginarAsignaciondeCartera />,
  },
  // TiposdeCompromiso
  {
    path: "dashboard/TiposdeCompromiso",
    element: <TiposdeCompromiso />,
  },
  {
    path: "dashboard/TiposdeCompromiso/crear",
    element: <CrearTiposdeCompromiso />,
  },
  {
    path: "dashboard/TiposdeCompromiso/editar",
    element: <EditarTiposdeCompromiso />,
  },
  // GestiondeCartera
  {
    path: "dashboard/GestiondeCartera",
    element: <GestiondeCartera />,
  },
  {
    path: "dashboard/GestiondeCartera/Detalle",
    element: <DetalleGestiondeCartera />,
  },
  // Agenda
  {
    path: "dashboard/Agenda",
    element: <Agenda />,
  },
  {
    path: "dashboard/Agenda/crear",
    element: <CrearAgenda />,
  },
  {
    path: "dashboard/Agenda/buscar",
    element: <BuscarAgenda />,
  },

  // TrasladoaDptoLegal
  {
    path: "dashboard/TrasladoaDptoLegal",
    element: <TrasladoaDptoLegal />,
  },
  {
    path: "dashboard/TrasladoaDptoLegal/Editar",
    element: <EditarTrasladoaDptoLegal />,
  },

  // DashboardCartera
  {
    path: "dashboard/DashboardCartera",
    element: <DashboardCartera />,
  },

  // ConsultadeCartera
  {
    path: "dashboard/ConsultadeCartera",
    element: <ConsultadeCartera />,
  },

  // Encuestas
  {
    path: "dashboard/Encuestas",
    element: <Encuestas />,
  },
  {
    path: "dashboard/Encuestas/crear",
    element: <CrearEncuestas />,
  },
  {
    path: "dashboard/Encuestas/editar",
    element: <EditarEncuestas />,
  },

  // AsigEncuestas
  {
    path: "dashboard/AsigEncuestas",
    element: <AsigEncuestas />,
  },
  {
    path: "dashboard/AsigEncuestas/Asignar",
    element: <AsignarAsigEncuestas />,
  },

  // EjecEncuestas
  {
    path: "dashboard/EjecEncuestas",
    element: <EjecEncuestas />,
  },
  {
    path: "dashboard/EjecEncuestas/Ejecutar",
    element: <EjecutarEjecEncuestas />,
  },

  // DashboardEncuesta
  {
    path: "dashboard/DashboardEncuesta",
    element: <DashboardEncuesta />,
  },

  // ControlElectoral\\
  /// /cordinador
  {
    path: "dashboard/ControlElectoral/Cordinador/DashboardCorRecin",
    element: <DashboardCordinador />,
  },
  {
    path: "dashboard/ControlElectoral/Cordinador/ControlAsis",
    element: <AsistenciaCordinador />,
  },
  {
    path: "dashboard/ControlElectoral/Cordinador/ReasigMesas",
    element: <ReasigMesasCordinador />,
  },
  {
    path: "dashboard/ControlElectoral/Cordinador/AlertasSeg",
    element: <AlertasSegCordinador />,
  },

  /// /delegado
  {
    path: "dashboard/ControlElectoral/Delegado/DashboardDeleMesa",
    element: <DashboardDelegado />,
  },
  {
    path: "dashboard/ControlElectoral/Delegado/IngresoActa",
    element: <IngresoActaDelegado />,
  },
  {
    path: "dashboard/ControlElectoral/Delegado/MisActas",
    element: <MisActasDelegado />,
  },
  {
    path: "dashboard/ControlElectoral/Delegado/ReportarIncidencia",
    element: <IncidenciaDelegado />,
  },
  {
    path: "dashboard/ControlElectoral/Delegado/Sincronizacion",
    element: <SincronizacionDelegado />,
  },

  /// /cuarto de control
  {
    path: "dashboard/ControlElectoral/CenCom/DashboardCentroComp",
    element: <DashboardCenCom />,
  },
  {
    path: "dashboard/ControlElectoral/CenCom/GeografiaElectoral",
    element: <GeografiaElectoralCenCom />,
  },
  {
    path: "dashboard/ControlElectoral/CenCom/AuditoriaActas",
    element: <AuditoriaActasCenCom />,
  },
  {
    path: "dashboard/ControlElectoral/CenCom/ReportesLegal",
    element: <ReportesExportacionLegalCenCom />,
  },
  /// /RecintosElectorales
  {
    path: "dashboard/ControlElectoral/RecintosElectorales",
    element: <RecintosElectorales />,
  },
  {
    path: "dashboard/ControlElectoral/RecintosElectorales/crear",
    element: <CrearRecintoElectoral />,
  },
  {
    path: "dashboard/ControlElectoral/RecintosElectorales/editar",
    element: <EditarRecintoElectoral />,
  },

  /// /JuntasReceptoras
  {
    path: "dashboard/ControlElectoral/JuntasReceptoras",
    element: <JuntasReceptoras />,
  },
  {
    path: "dashboard/ControlElectoral/JuntasReceptoras/crear",
    element: <CrearJuntasReceptoras />,
  },
  {
    path: "dashboard/ControlElectoral/JuntasReceptoras/editar",
    element: <EditarJuntasReceptoras />,
  },

  /// /Candidatos
  {
    path: "dashboard/ControlElectoral/Candidatos",
    element: <Candidatos />,
  },
  {
    path: "dashboard/ControlElectoral/Candidatos/crear",
    element: <CrearCandidatos />,
  },
  {
    path: "dashboard/ControlElectoral/Candidatos/editar",
    element: <EditarCandidatos />,
  },

  /// /DelegadosCordinadores
  {
    path: "dashboard/ControlElectoral/DelegadosCordinadores",
    element: <DelegadosCordinadores />,
  },
  {
    path: "dashboard/ControlElectoral/DelegadosCordinadores/crear",
    element: <CrearDelegadosCordinadores />,
  },
  {
    path: "dashboard/ControlElectoral/DelegadosCordinadores/editar",
    element: <EditarDelegadosCordinadores />,
  },

  { path: "dashboard/LineasINV", element: <LineasINV /> },
  { path: "dashboard/LineasINV/crear", element: <CrearLineasINV /> },
  { path: "dashboard/LineasINV/editar", element: <EditarLineasINV /> },
  { path: "dashboard/MarcasINV", element: <MarcasINV /> },
  { path: "dashboard/MarcasINV/crear", element: <CrearMarcasINV /> },
  { path: "dashboard/MarcasINV/editar", element: <EditarMarcasINV /> },
  { path: "dashboard/MedidasINV", element: <MedidasINV /> },
  { path: "dashboard/MedidasINV/crear", element: <CrearMedidasINV /> },
  { path: "dashboard/MedidasINV/editar", element: <EditarMedidasINV /> },
  { path: "dashboard/PresentacionesINV", element: <PresentacionesINV /> },
  { path: "dashboard/PresentacionesINV/crear", element: <CrearPresentacionesINV /> },
  { path: "dashboard/PresentacionesINV/editar", element: <EditarPresentacionesINV /> },
  { path: "dashboard/Transportistas", element: <Transportistas /> },
  { path: "dashboard/Transportistas/crear", element: <CrearTransportistas /> },
  { path: "dashboard/Transportistas/editar", element: <EditarTransportistas /> },
  { path: "dashboard/ServiciosNDNC", element: <ServiciosNDNC /> },
  { path: "dashboard/ServiciosNDNC/crear", element: <CrearServiciosNDNC /> },
  { path: "dashboard/ServiciosNDNC/editar", element: <EditarServiciosNDNC /> },
  { path: "dashboard/Bodegas", element: <Bodegas /> },
  { path: "dashboard/Bodegas/crear", element: <CrearBodegas /> },
  { path: "dashboard/Bodegas/editar", element: <EditarBodegas /> },
  { path: "dashboard/Colores", element: <Colores /> },
  { path: "dashboard/Colores/crear", element: <CrearColores /> },
  { path: "dashboard/Colores/editar", element: <EditarColores /> },
  { path: "dashboard/Regiones", element: <Regiones /> },
  { path: "dashboard/Regiones/crear", element: <CrearRegiones /> },
  { path: "dashboard/Regiones/editar", element: <EditarRegiones /> },
  { path: "dashboard/TipoSolicitud", element: <TipoSolicitud /> },
  { path: "dashboard/TipoSolicitud/crear", element: <CrearTipoSolicitud /> },
  { path: "dashboard/TipoSolicitud/editar", element: <EditarTipoSolicitud /> },
  { path: "dashboard/TipoMotivo", element: <TipoMotivo /> },
  { path: "dashboard/TipoMotivo/crear", element: <CrearTipoMotivo /> },
  { path: "dashboard/TipoMotivo/editar", element: <EditarTipoMotivo /> },
  { path: "dashboard/TipoTransacciones", element: <TipoTransacciones /> },
  { path: "dashboard/TipoTransacciones/crear", element: <CrearTipoTransacciones /> },
  { path: "dashboard/TipoTransacciones/editar", element: <EditarTipoTransacciones /> },
  { path: "dashboard/AsignacionTipoSolaUsu", element: <AsignacionTipoSolaUsu /> },
  { path: "dashboard/CatalogodeProductos", element: <CatalogodeProductos /> },
  { path: "dashboard/CatalogodeProductos/crear", element: <CrearCatalogodeProductos /> },
  { path: "dashboard/CatalogodeProductos/editar", element: <EditarCatalogodeProductos /> },
  { path: "dashboard/CatalogodeProductos/buscar", element: <BuscarCatalogodeProductos /> },
  { path: "dashboard/JefedeProductos", element: <JefedeProductos /> },
  { path: "dashboard/JefedeProductos/crear", element: <CrearJefedeProductos /> },
  { path: "dashboard/JefedeProductos/editar", element: <EditarJefedeProductos /> },
  { path: "dashboard/CrearSolicitudIngEgr", element: <CrearSolicitudIngEgr /> },
  { path: "dashboard/CrearSolicitudIngEgr/crear", element: <CrearCrearSolicitudIngEgr /> },
  { path: "dashboard/CrearSolicitudIngEgr/editar", element: <EditarCrearSolicitudIngEgr /> },
  { path: "dashboard/AprobacionSolIngEgr", element: <AprobacionSolIngEgr /> },
  { path: "dashboard/AprobacionSolIngEgr/editar", element: <EditarAprobacionSolIngEgr /> },
  { path: "dashboard/IngEgrporSolicitud", element: <IngEgrporSolicitud /> },
  { path: "dashboard/IngEgrporSolicitud/editar", element: <EditarIngEgrporSolicitud /> },
  { path: "dashboard/IngEgrporSolicitud/buscar", element: <BuscarIngEgrporSolicitud /> },
  { path: "dashboard/ConsultasCobrosAplA", element: <ConsultasCobrosAplA /> },
  { path: "dashboard/ConsultasCobrosAplA/detalle", element: <DetalleConsultasCobrosAplA /> },
  { path: "dashboard/TomaFisica", element: <TomaFisica /> },
  { path: "dashboard/TomaFisica/crear", element: <CrearTomaFisica /> },
  { path: "dashboard/TomaFisica/detalle", element: <DetalleTomaFisica /> },
  { path: "dashboard/TomaFisica/buscar", element: <BuscarTomaFisica /> },
  { path: "dashboard/TomaFisicaMovil", element: <TomaFisicaMovil /> },
  { path: "dashboard/TomaFisicaMovil/crear", element: <CrearTomaFisicaMovil /> },
  { path: "dashboard/ResumenProductosbodegas", element: <ResumenProductosbodegas /> },
  { path: "dashboard/RetencionMasiva", element: <RetencionMasiva /> },
]
export default protectedRoutes
